const cases = [
  {
    stat: "+32%",
    label: "More booked jobs",
    desc: "Increased booked jobs by 32% through automated intake and follow-up sequences.",
    industry: "Construction",
    icon: "ri-bar-chart-grouped-line",
  },
  {
    stat: "−40%",
    label: "Admin workload",
    desc: "Reduced administrative overhead by 40% across clinical operations staff.",
    industry: "Clinical",
    icon: "ri-time-line",
  },
  {
    stat: "3×",
    label: "Coordination speed",
    desc: "Improved project coordination speed across multi-team environments with unified workflows.",
    industry: "Engineering",
    icon: "ri-team-line",
  },
];

export default function CasePreview() {
  return (
    <section
      className="bg-white py-28 px-6 md:px-10"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      <div className="max-w-6xl mx-auto">
        {/* Heading */}
        <div className="text-center mb-16">
          <p className="text-xs font-medium text-[#4F46E5] uppercase tracking-widest mb-4">
            Results
          </p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold text-[#1F2933] tracking-[-0.03em] leading-[1.08]">
            What This Looks Like
            <br />
            <span className="text-[#6B7280] font-normal">in Practice.</span>
          </h2>
        </div>

        {/* Wide visual + metrics layout */}
        <div className="rounded-[24px] border border-[#E5E7EB] overflow-hidden">
          {/* Top image strip */}
          <div className="w-full h-56 overflow-hidden relative">
            <img
              src="https://public.readdy.ai/ai/img_res/4b5be738dc081501065486f53a702618.jpg"
              alt="Noveka AI in practice"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-white/70" />
          </div>

          {/* Metrics */}
          <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-[#E5E7EB] bg-white">
            {cases.map((c) => (
              <div
                key={c.label}
                className="group p-8 lg:p-10 hover:bg-[#FAFAFA] transition-colors duration-200"
              >
                <span className="inline-flex items-center px-2.5 py-1 rounded-full bg-[#F7F8FA] border border-[#E5E7EB] text-xs font-medium text-[#6B7280] mb-6">
                  {c.industry}
                </span>

                <div className="flex items-end gap-3 mb-4">
                  <span
                    className="text-5xl font-semibold tracking-[-0.04em] leading-none"
                    style={{
                      background: "linear-gradient(135deg, #4F46E5 0%, #818CF8 100%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundClip: "text",
                    }}
                  >
                    {c.stat}
                  </span>
                </div>

                <p className="text-sm font-semibold text-[#1F2933] mb-2">{c.label}</p>
                <p className="text-sm text-[#6B7280] leading-relaxed">{c.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
